import { CALL_API } from './api'
import { getToken } from 'Lib'

export default store => next => action => {
  const entry = action[CALL_API]

  if (typeof entry !== 'object') return next(action)

  let token
  const entryType = entry.types[0]

  if (entryType.startsWith("CORE") || entry.types[0].startsWith("O365") || entry.types[0].startsWith("SERVICE")) {
    token = getToken()
  }
  // else if (entry.types[0].startsWith("SERVICE")) {
  //   token = getO365Token()
  // }

  if (!token) return next(action)

  entry.headers = { ...entry.headers, 'Authorization': `Bearer ${token}` }

  next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/setToken.js